import { Box, Grid2, Paper, Tab, Tabs, Typography, useTheme } from '@mui/material';
import React, { FC, useEffect, useMemo } from 'react';
import { Can } from '../../../Components/Can';
import { BarChartComponent } from '../../../Components/Charts/BarChart/bar-chart.component';
import { DoubleBarChartComponent } from '../../../Components/Charts/DoubleBarChart/double-bar-chart.component';
import { PieChartComponent } from '../../../Components/Charts/PieChart/pie-chart.component';
import { Flex } from '../../../Components/Flex/flex.component';
import { KanbanBoardProduction } from '../../../Components/KanbanBoardProduction/kanban-board.component';
import { Loader } from '../../../Components/Loader';
import Notice from '../../../Components/Notice/notice.component';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { CustomTabPanel } from '../../../Components/Tabs/CustomTabPanel/custom-tab-panel.component';
import { Tag } from '../../../Components/Tag/tag.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ServiceOrderDueDateStatusEnum, ServiceOrderStageEnum, ServiceOrderStatusEnum } from '../../../Services/api/service-orders/service-order.interface';
import { ListServiceOrdersUseCase } from '../../../Usecase/ServiceOrders/list-service-orders-usecase';
import { ShowServiceOrdersUseCase } from '../../../Usecase/ServiceOrders/show-service-orders-usecase';
import { UpdateServiceOrdersUseCase } from '../../../Usecase/ServiceOrders/update-service-orders-usecase';
import { a11yProps } from '../../../utils/a11yProps';
import { labelsOrderProductionStage, normalizeOrderProductionStage } from '../../../utils/normalizeProductionStages';
import { labelsOrderProductionStatus, normalizeOrderProductionStatus } from '../../../utils/normalizeProductionStatus';
import { labelsTimeStatusProduction, normalizeTimeStatusColors } from '../../../utils/normalizeTimeStatus';
import { useListProduction } from './production-list.hook';

interface IProductionList {
   
    listServiceOrdersUseCase : ListServiceOrdersUseCase
    showServiceOrdersUseCase: ShowServiceOrdersUseCase
    updateServiceOrdersUseCase: UpdateServiceOrdersUseCase
}


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const ProductionList : FC<IProductionList> = ({  listServiceOrdersUseCase, showServiceOrdersUseCase, updateServiceOrdersUseCase }) => {
    const theme = useTheme();

    const { listProduction, list, data, handleShowDetails, handleConfirmProductionItems, kanbanSchema ,handleShowOrderDetails, orderDetails, setOrderDetails, tabValue,
      handleChangeTab, setProductionTypeView, productionTypeView, totalRegisters, handleNavigateDetails, itemsData, loading } = useListProduction({
      listServiceOrdersUseCase,
      showServiceOrdersUseCase,
      updateServiceOrdersUseCase
    })

 
    useEffect(() => {
        listProduction({ page: 1})
    }, [])

    const columns = useMemo(() => {
      const createColumns: any[] = [
        {
          field: 'externalProductionId',
        headerName: 'Ordem de Produção',
          width: 200,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{`#${params?.row?.externalProductionId || 'Sem OP Atribuída'}`}</Typography></Flex>
        },
        {
          field: 'quantity',
          headerName: 'Quantidade de Produtos',
          width: 200,
          align: 'center',
          headerAlign: 'center',
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}><Typography>{params.row?.products?.length} {params.row?.products?.length > 1 ? 'produtos' : 'produto'}</Typography></Flex>
        },
        {
          field: 'code',
          headerName: 'Produtos Atrasados',
          width: 200,
          align: 'center',
          headerAlign: 'center',
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}><Typography>{params.row?.products?.length} {params.row?.products?.length > 1 ? 'produtos' : 'produto'}</Typography></Flex>
        },
        {
          field: 'products',
          headerName: 'Produto',
          flex: 1,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params.row?.products?.length ? String(params.row?.products[0]?.product?.name)?.toUpperCase() : 'Não informado'} </Typography></Flex>
          
        },
        {
          field: "status",
          headerName: "Status",
          width: 200,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}>
            <Tag 
                  title={labelsOrderProductionStatus[params.row.status as ServiceOrderStatusEnum] || 'Desconhecido'} 
                  boxStyle={{ backgroundColor: normalizeOrderProductionStatus(params.row.status as ServiceOrderStatusEnum)?.bgColor }} 
                  titleStyle= {{ color: normalizeOrderProductionStatus(params.row.status as ServiceOrderStatusEnum)?.textColor, fontSize: '15px' }} 
                  wrapperStyle={{ width: '100%' }} 
                />
           
            
            </Flex>
        },
        {
          field: "actions",
          headerName: "Etapa",
          headerAlign: "center",
          width: 300,
          renderCell: (params: any) => <Box style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}>
            {params.row.stages.map((item: ServiceOrderStageEnum) => (
              <Box sx={{ display: 'flex', alignItems: 'center', margin: 0, padding: 0}} key={item}>
                <Tag 
                  title={labelsOrderProductionStage[item] || 'Desconhecido'} 
                  boxStyle={{ backgroundColor: normalizeOrderProductionStage(item)?.bgColor }} 
                  titleStyle= {{ color: normalizeOrderProductionStage(item)?.textColor, fontSize: '15px' }} 
                  wrapperStyle={{ width: '100%' }} 
                />
              </Box>
            ))}
            
            </Box>
        }
      ];
    
      return createColumns;
    }, []);

    const itemsColumn = useMemo(() => {
      const createColumns: any[] = [
        {
          field: 'order_id',
          headerName: 'Número do pedido',
          flex: 1,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{`#${params.row.order_id}`}</Typography></Flex>
        },
        {
          field: 'customer',
          headerName: 'Cliente',
          flex: 1,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params.row?.customer} {params.row?.customer > 1 ? 'produtos' : 'produto'}</Typography></Flex>
        },
        {
          field: 'product',
          headerName: 'Produto',
          flex: 1,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params?.row?.product}</Typography></Flex>
        },
        {
          field: 'price',
          headerName: 'Preço',
          width: 100,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params.row.price}</Typography></Flex>
        },
        {
          field: 'quantity',
          headerName: 'Tiragem',
          width: 100,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params?.row?.quantity}</Typography></Flex>
        },
        {
          field: 'os_number',
          headerName: 'Ordem de Serviço',
          width: 140,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params?.row?.os_number}</Typography></Flex>
        },
        {
          field: 'dueDateStatus',
          headerName: 'Prazo',
          width: 130,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}>
            <Box sx={{height: '100%', display: 'flex', alignItems: 'center', margin: 0, padding: 0}}>
              <Tag 
                title={labelsTimeStatusProduction[params.row.dueDateStatus as ServiceOrderDueDateStatusEnum] || 'Desconhecido'}
                boxStyle={{ backgroundColor: normalizeTimeStatusColors(params.row.status)?.bgColor }} 
                titleStyle={{ color: normalizeTimeStatusColors(params.row.status)?.textColor, fontSize: '15px' }} />
              </Box>
            </Flex>
        },
        {
          field: 'approvation_date',
          headerName: 'Data de Aprovação',
          width: 150,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params?.row?.approvation_date}</Typography></Flex>
        },
        
        {
          field: 'card',
          headerName: 'Cartela',
          width: 100,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer'}}><Typography>{params?.row?.card}</Typography></Flex>
        },
      
        {
          field: "step",
          headerName: "Etapa",
          headerAlign: "center",
          width: 200,
          renderCell: (params: any) => <Flex sx={{ height: '100%', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}><Box sx={{height: '100%', display: 'flex', alignItems: 'center', margin: 0, padding: 0}}><Tag title={labelsOrderProductionStatus[params.row.status as ServiceOrderStatusEnum] || 'Desconhecido'} boxStyle={{ backgroundColor: normalizeOrderProductionStatus(params.row.status)?.bgColor }} titleStyle={{ color: normalizeOrderProductionStatus(params.row.status)?.textColor, fontSize: '15px' }} /></Box></Flex>
        }
      ];
    
      return createColumns;
    }, []);
 


    return (
      <Can permissions={['menu:production:manage']}>  
        <BaseScreen withSideBar={false}>
            <Paper >
              {loading && <Loader />}

              {/* {orderDetails?.id && <SaleDetailsModal onClose={() => setOrderDetails(undefined)} data={orderDetails} />} */}
                <BaseContentPage 
                    title='Produção'
                    
                    breadcrumb={[{ title: 'Produção', link: "/production-list"}, { title: 'Listagem'}]}
                    Action={() =>  <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
                          <Tab label="Ordem de Produção" {...a11yProps(0)} />
                          {/* <Tab label="Itens para Produzir" {...a11yProps(1)} />
                        <Tab label="Dashboard" {...a11yProps(2)} /> */}
                    </Tabs>}
                   
                >

                <CustomTabPanel value={tabValue} index={0}>
                  {/* <Flex justifyContent='flex-end' width='100%' marginTop='-20px' marginBottom='20px'>
                    <ButtonGroupCustom selected={productionTypeView} items={[
                      {
                        value: '0',
                        label: 'Lista',
                        icon: <FaList style={{ width: '15px', height: '15px', color: String(productionTypeView) === '0' ? '#FFF' : theme.palette.primary.light}} />
                      },
                      // {
                      //   value: '1',
                      //   label: 'Kanban',
                      //   icon: <BsKanban style={{ width: '15px', height: '15px', color: String(productionTypeView) === '1' ? '#FFF' : theme.palette.primary.light}} />
                      // }
                    ]}
                    onSelect={setProductionTypeView}
                    />
                  </Flex> */}

                  {productionTypeView === '0' ? !!list?.length ? <Table onRowClick={(e) =>  handleNavigateDetails(e)} isRowSelectable={() => false} data={list} columns={columns} onPageChange={listProduction} totalCount={totalRegisters} disableRowSelectionOnClick={false} /> : <Placeholder description='Nenhum dado encontrado.'   /> :  !!kanbanSchema?.columnOrder?.length ?  <KanbanBoardProduction handleShowOrderDetails={handleShowOrderDetails} handleConfirmProductionItems={handleConfirmProductionItems} initialData={kanbanSchema} details={orderDetails} setOrderDetails={setOrderDetails} canClick={true} canDrag={true} /> : <Placeholder description='Nenhum dado encontrado.' />}

                

                  
                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={1}>
                  <Grid2 container spacing={2} >
                      <Grid2 size={6}>
                        <Notice
                          title='Produções atrasadas'
                          description='Atualmente existem 214 item(s) atrasados.'
                          status='fail'
                          sx={{ minHeight: '115px'}}
                          />
                      </Grid2>

                      <Grid2 size={6}>
                        <Notice
                          title='Produções prestes a vencer'
                          subtitle='(Vencimento nos próximos 3 dias)'
                          description='Atualmente existem 60 item(s) prestes a vencer.'
                          status='warning'
                          />
                      </Grid2>

                      <Grid2 size={12}>
                        <Table onRowClick={(e) =>  handleNavigateDetails(e)} isRowSelectable={() => false} data={itemsData} columns={itemsColumn} onPageChange={listProduction} totalCount={totalRegisters} disableRowSelectionOnClick={false} />
                      
                      </Grid2>                    

                          

                    </Grid2>
                    
                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={2}>
                    
                <Grid2  container spacing={2} >
                  <Grid2 size={6}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Pedidos por prazo</Typography>
                        <Typography  fontSize='19px'>569 pedidos</Typography>
                        <PieChartComponent data={[{ name: 'Atrasado', value: 106, fill: '#FF0000' }, { name: 'Em Dia', value: 438, fill: '#9cb934' }, { name: 'Prestes a Vencer', value: 25, fill: '#ffbb28' }]} />
                      </Box>
                    </Paper>
                  </Grid2>

                  <Grid2 size={6}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Pedidos por prazo (Valor)</Typography>
                        <Typography  fontSize='19px'>R$ 408.549,2</Typography>
                        <PieChartComponent data={[{ name: 'Atrasado', value: 106, fill: '#FF0000' }, { name: 'Em Dia', value: 438, fill: '#9cb934' }, { name: 'Prestes a Vencer', value: 25, fill: '#ffbb28' }]} />
                      </Box>
                    </Paper>
                  </Grid2>

                  <Grid2 size={6}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Pedidos produzidos</Typography>
                        <Typography  fontSize='19px'>5282 pedidos produzidos</Typography>
                        <BarChartComponent format='values' data={[{ name: 'Total', value: 5282, fill: '#FF0000' }, { name: 'Produzido dentro do prazo', value: 141, fill: '#9cb934' }, { name: 'Produzido fora do prazo', value: 5141, fill: '#ffbb28' }]} />
                      </Box>
                    </Paper>
                  </Grid2>

                  <Grid2 size={6}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Itens por prazo</Typography>
                        <Typography  fontSize='19px'>879 itens</Typography>
                        <PieChartComponent data={[{ name: 'Prestes a Vencer', value: 41, fill: '#FF0000' }, { name: 'Vencidos', value: 149, fill: '#9cb934' }, { name: 'Em dia', value: 689, fill: '#ffbb28' }]} />
                      </Box>
                    </Paper>
                  </Grid2>

                  <Grid2 size={12}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Itens por status</Typography>
                        <Typography  fontSize='19px'>879 itens para produzir</Typography>
                        <DoubleBarChartComponent
                          data={[
                            { name: 'Destaque', value1: 130, value2: 38, fill1: '#ffbb28', fill2: '#9cb934' },
                            { name: 'OS Emitida', value1: 124, value2: 47, fill1: '#ffbb28', fill2: '#9cb934'  },
                            { name: 'Aguar. P/Finalizar', value1: 44, value2: 20, fill1: '#ffbb28', fill2: '#9cb934'  },
                            { name: 'Início', value1: 508, value2: 3, fill1: '#ffbb28', fill2: '#9cb934'  },
                            { name: 'Corte e Vinco Manual', value1: 36, value2: 10, fill1: '#ffbb28', fill2: '#9cb934'  },
                            { name: 'Pré Impressão', value1: 10, value2: 10, fill1: '#ffbb28', fill2: '#9cb934'  },
                            { name: 'Corte e Vinco Auto', value1: 35, value2: 29, fill1: '#ffbb28', fill2: '#9cb934'  },
                          ]}
                        />

                      </Box>
                    </Paper>
                  </Grid2>

                  <Grid2 size={6}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Itens produzidos</Typography>
                        <Typography  fontSize='19px'>8914 itens produzidos</Typography>
                        <BarChartComponent format='values' data={[{ name: 'Total', value: 5282, fill: '#FF0000' }, { name: 'Produzido dentro do prazo', value: 141, fill: '#9cb934' }, { name: 'Produzido fora do prazo', value: 5141, fill: '#ffbb28' }]} />
                      </Box>
                    </Paper>
                  </Grid2>

                  <Grid2 size={6}>
                    <Paper>
                      <Box padding='20px'>
                        <Typography fontSize='24px' fontWeight='bold'>Itens de Pedidos Atrasados</Typography>
                        <Typography  fontSize='19px'>67 itens atrasados</Typography>
                        <BarChartComponent format='values' data={[{ name: 'OS Emitida', value: 44, fill: '#FF0000' }, { name: 'Corte e Vinco Auto', value: 23, fill: '#FF0000' }, { name: 'Destaque', value: 31, fill: '#FF0000' }, { name: 'Início', value: 3, fill: '#FF0000' }, { name: 'Corte e Vinco Manual', value: 3, fill: '#FF0000' }, { name: 'Aguar. P/Finalizar', value: 20, fill: '#FF0000' }, { name: 'Pré Impressão', value: 2, fill: '#FF0000' }]} />
                      </Box>
                    </Paper>
                  </Grid2>

                  
                </Grid2>

             
                    

                  
                </CustomTabPanel>

                 
 
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
      )
}

export { ProductionList };
